import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Nutrición Resuelta — Consulta Resuelta™';
// Preconnect to critical origins BEFORE React renders
const origins = ['https://res.cloudinary.com', 'https://images.unsplash.com'];
origins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preconnect to the Meta Pixel origin so it connects faster when it loads
const fbPreconnect = document.createElement('link');
fbPreconnect.rel = 'preconnect';
fbPreconnect.href = 'https://connect.facebook.net';
fbPreconnect.crossOrigin = 'anonymous';
document.head.appendChild(fbPreconnect);
// Preload hero image for faster LCP — MUST match the actual src rendered in App.tsx
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.setAttribute('fetchpriority', 'high');
preloadImg.href = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_400/v1777947518/hf_20260505_021521_8449f97b-f5da-48cc-920a-25564eca795d-Photoroom_fekoru.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-371" />, document.getElementById('root'));